module.exports = __webpack_public_path__ + "img/hr-V-L-3-unload-standup-shadow.a967cec1.png";